import { useState, useEffect, useCallback } from "react"
import {
  getGlitchEnabled,
  setGlitchEnabled as setStorage,
  GLITCH_ENABLED_CHANGE_EVENT,
  BRANDING_GLITCH_CHANGE_EVENT,
} from "./glitchEnabled"

export function useGlitchEnabled(): [boolean, (value: boolean) => void] {
  const [value, setValue] = useState(getGlitchEnabled)

  useEffect(() => {
    const handler = () => setValue(getGlitchEnabled())
    window.addEventListener(GLITCH_ENABLED_CHANGE_EVENT, handler)
    window.addEventListener(BRANDING_GLITCH_CHANGE_EVENT, handler)
    return () => {
      window.removeEventListener(GLITCH_ENABLED_CHANGE_EVENT, handler)
      window.removeEventListener(BRANDING_GLITCH_CHANGE_EVENT, handler)
    }
  }, [])

  const set = useCallback((v: boolean) => {
    setStorage(v)
    setValue(getGlitchEnabled())
  }, [])

  return [value, set]
}
